var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32.5C25.3366 32.5 32.5 25.3366 32.5 16.5C32.5 7.66344 25.3366 0.5 16.5 0.5C7.66344 0.5 0.5 7.66344 0.5 16.5C0.5 25.3366 7.66344 32.5 16.5 32.5Z",
    stroke: "#00703E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0306 12.9443L16.2851 17.1072L21.5319 12.9443H11.0306ZM10.2773 13.4442V19.8015H22.2765V13.4476L16.5513 17.9936C16.4755 18.0535 16.3817 18.0861 16.2851 18.0861C16.1884 18.0861 16.0946 18.0535 16.0188 17.9936L10.2782 13.4442H10.2773Z",
    fill: "#00703E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.26dd6daece1b93052d37c4776e7bd334.svg";
export { ForwardRef as ReactComponent };